import ReferralSourcesContainer from '../../../containers/ReferralSourcesContainer'

const ReferralSources = () => {
  return (
    <ReferralSourcesContainer />
  )
}

export default ReferralSources